import React, { useContext, useState } from 'react';
import { ITypeCartFields, VignetteContext } from '@adac-mp/shared';
import { Badge, CartIcon, CheckSuccess, CircularProgressBar, IconButton, Typography } from '../../index';
import { useHeaderNavbarOffset } from '../../hooks/useHeaderNavbarOffset';
import { useFlowId } from '../../hooks/useFlowId';
interface IMiniCartProps {
	cartItemsCount: number;
	currStep?: number;
	cartUpdatedMessage?: string;
	step?: number;
	totalSteps?: number;
	setIsOpen: (isOpen: boolean) => void;
	onAnimationEnd?: () => void;
}

export const MiniCartIcon = ({
	currStep,
	totalSteps,
	cartItemsCount,
	step,
	cartUpdatedMessage,
	setIsOpen,
	onAnimationEnd = () => {},
}: IMiniCartProps) => {
	const { contentfulLabels } = useContext(VignetteContext);
	const cartLabels = contentfulLabels?.cart as ITypeCartFields;
	const flowId = useFlowId();
	const isOneCartFlow = flowId === 0;
	const { topOffset } = useHeaderNavbarOffset();
	const [animatePulse, setAnimatePulse] = useState(false);
	const hasProgressBar = isOneCartFlow ? Number(step) > 2 : Number(step) > 1;
	const renderBagde = cartItemsCount > 0 && (!cartUpdatedMessage || animatePulse);

	return (
		<div
			className={`${hasProgressBar ? 'rounded-half' : 'rounded'} ${
				cartUpdatedMessage && 'animate-miniCartBtnWidthSm sm:animate-miniCartBtnWidthLg'
			} cursor-pointer border-none box-border bg-white rounded flex items-center h-[52px] w-[52px] sticky z-50 left-full -translate-x-1.5 shadow-outerShadow transition-[background-color, box-shadow] duration-200 hover:shadow-black/[0.1]`}
			style={{ top: topOffset + 8 }}
			onAnimationEnd={() => {
				setAnimatePulse(true);
				sessionStorage.removeItem('newProductsCount');
			}}>
			{renderBagde && (
				<Badge
					color="yellow"
					className={`absolute -top-1 -right-1 rounded-half z-100 ${animatePulse && 'animate-pulse'}`}
					onAnimationEnd={onAnimationEnd}>
					{cartItemsCount}
				</Badge>
			)}
			<IconButton
				data-cy="icon: mini-cart"
				className={`absolute border-none z-50 p-2.5 right-0 rounded inline-flex items-center justify-center bg-white h-full w-[52px] ${
					hasProgressBar ? 'rounded-half' : 'rounded'
				} transition-[background-color] duration-200 hover:bg-gray-700`}
				title={cartLabels?.cart}
				onClick={() => setIsOpen(true)}>
				<CircularProgressBar
					className={`absolute overflow-hidden pointer-events-none rotate-[60deg] -top-0.5 -left-0.5 ${
						hasProgressBar ? 'opacity-1' : 'opacity-0'
					}`}
					size={56}
					step={Number(currStep) / Number(totalSteps)}
				/>
				<CartIcon />
			</IconButton>
			{cartUpdatedMessage && (
				<Typography className="inline-flex items-center gap-1.5 pl-3 overflow-hidden" size="base">
					<CheckSuccess className="shrink-0" fill="#ffcc00" stroke="#3D3D3D" />
					<span className="block truncate w-[calc(100%_-_66px)]">{cartUpdatedMessage}</span>
				</Typography>
			)}
		</div>
	);
};
